import { ADICIONAR_FILTRO_PEDIDO } from '../types'

export default function adicionarFiltroPedido (filtro) {
  return {
    type: ADICIONAR_FILTRO_PEDIDO,
    payload: filtro
  }
}
